"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowUpCircleIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** ArrowUpCircleIcon */
var ArrowUpCircleIcon = function ArrowUpCircleIcon(props) {
  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement("title", null, "reveal less"), _react.default.createElement("path", {
    d: "M9 1.889A7.111 7.111 0 1 1 9 16.11 7.111 7.111 0 0 1 9 1.89zM9 1a8 8 0 1 0 0 16A8 8 0 0 0 9 1zm4.302 9.387L9 5.987 4.698 10.43l.79.782 3.556-3.555 3.512 3.51.746-.781z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.ArrowUpCircleIcon = ArrowUpCircleIcon;
ArrowUpCircleIcon.displayName = "ArrowUpCircleIcon";
//# sourceMappingURL=ArrowUpCircleIcon.js.map